function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-hot-toast';
import { MESSAGES, DIRECTORY_UPLOAD_PROPS } from '@edusense/shared-project-upload-constants';
import { countFiles, createZipFromFiles, validateRequiredFiles, isZipFile, analyzeZipFile } from '@edusense/shared-project-upload-utils';
import { PROJECT_UPLOAD_TEST_IDS, API_BASE_URLS, PROJECT_ENDPOINTS } from '@edusense/shared-constants';
import { tokenManager } from '@edusense/shared-auth-core';
import { useMediaUpload } from './legacy/useMediaUpload';
import { useFileUpload } from './legacy/useFileUpload';
/**
 * 프로젝트 업로드 페이지의 모든 비즈니스 로직을 담은 훅
 */ export var useProjectUpload = function(param) {
    var onUploadComplete = param.onUploadComplete, onCancel = param.onCancel, initialProject = param.initialProject;
    var navigate = useNavigate();
    // 폼 상태 관리
    var _useState = _sliced_to_array(useState({
        title: (initialProject === null || initialProject === void 0 ? void 0 : initialProject.title) || '',
        description: (initialProject === null || initialProject === void 0 ? void 0 : initialProject.description) || '',
        tags: (initialProject === null || initialProject === void 0 ? void 0 : initialProject.tags) || []
    }), 2), formValues = _useState[0], setFormValues = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isSubmitting = _useState1[0], setIsSubmitting = _useState1[1];
    // 미디어 업로드 훅 사용
    var _useMediaUpload = useMediaUpload({
        initialMedia: (initialProject === null || initialProject === void 0 ? void 0 : initialProject.media) || []
    }), media = _useMediaUpload.media, isMediaUploading = _useMediaUpload.isMediaUploading, mediaUploadError = _useMediaUpload.mediaUploadError, triggerMediaUpload = _useMediaUpload.triggerMediaUpload, handleMediaUpload = _useMediaUpload.handleMediaUpload, handleRemoveMedia = _useMediaUpload.handleRemoveMedia, mediaInputRef = _useMediaUpload.mediaInputRef;
    // 미디어 업로더에 필요한 상태값 변환
    var mediaUploadStatus = isMediaUploading ? 'uploading' : 'idle';
    // 프로젝트 파일 유효성 검사 피드백 상태
    var _useState2 = _sliced_to_array(useState({
        message: null,
        type: 'info'
    }), 2), validationFeedback = _useState2[0], setValidationFeedback = _useState2[1];
    // 파일 업로드 훅 사용
    var _useFileUpload = useFileUpload({
        onUploadSuccess: function(newFileTree, uploadedFiles) {
            console.log('[useProjectUpload] 파일 업로드 성공 (폴더), 수신된 fileTree:', newFileTree);
            var fileCount = countFiles(newFileTree);
            toast.success(MESSAGES.SUCCESS.FILES_UPLOADED(fileCount));
            setUploadedZipFile(null);
        }
    }), fileTree = _useFileUpload.fileTree, setFileTree = _useFileUpload.setFileTree, projectFiles = _useFileUpload.projectFiles, setProjectFiles = _useFileUpload.setProjectFiles, isProjectFilesUploading = _useFileUpload.isUploading, fileUploadProgress = _useFileUpload.uploadProgress, uploadError = _useFileUpload.uploadError, setUploadError = _useFileUpload.setUploadError, triggerFolderUpload = _useFileUpload.triggerFolderUpload, handleFolderUpload = _useFileUpload.handleFolderUpload, folderInputRef = _useFileUpload.folderInputRef, handleDropFolder = _useFileUpload.handleDropFolder;
    // 파일 업로더에 필요한 상태값 변환
    var fileUploadStatus = isProjectFilesUploading ? 'uploading' : 'idle';
    // ZIP 파일 업로드 상태
    var _useState3 = _sliced_to_array(useState(null), 2), uploadedZipFile = _useState3[0], setUploadedZipFile = _useState3[1];
    var zipInputRef = useRef(null);
    // projectFiles 상태 변경 시 유효성 검사 수행
    useEffect(function() {
        if (projectFiles && projectFiles.length > 0) {
            console.log('[useProjectUpload] projectFiles 변경 감지, 유효성 검사 시작:', projectFiles);
            var validationResult = validateRequiredFiles(projectFiles);
            if (!validationResult.isValid) {
                setValidationFeedback({
                    message: MESSAGES.WARNING.MISSING_FILES(validationResult.missingFiles),
                    type: 'warning'
                });
            } else {
                setValidationFeedback({
                    message: MESSAGES.SUCCESS.VALIDATION_SUCCESS,
                    type: 'success'
                });
            }
        } else {
            setValidationFeedback({
                message: null,
                type: 'info'
            });
        }
    }, [
        projectFiles
    ]);
    // 콘솔 로그: fileTree 상태 확인
    useEffect(function() {
        console.log('[useProjectUpload] fileTree 상태 변경:', fileTree);
    }, [
        fileTree
    ]);
    // 폼 필드 변경 핸들러
    var handleFormChange = useCallback(function(field, value) {
        setFormValues(function(prev) {
            return _object_spread_props(_object_spread({}, prev), _define_property({}, field, value));
        });
    }, []);
    // 미디어 삭제 핸들러 어댑터 (index를 id로 변환)
    var handleRemoveMediaAdapter = useCallback(function(id) {
        var index = parseInt(id, 10);
        if (!isNaN(index)) {
            handleRemoveMedia(index);
        }
    }, [
        handleRemoveMedia
    ]);
    // ZIP 파일 변경 핸들러
    var handleZipFileChange = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            var _event_target_files, file, _ref, newFileTree, fileList, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        file = (_event_target_files = event.target.files) === null || _event_target_files === void 0 ? void 0 : _event_target_files[0];
                        console.log('[useProjectUpload] 선택된 파일:', file);
                        if (!file) {
                            console.log('[useProjectUpload] 파일이 선택되지 않음');
                            return [
                                2
                            ];
                        }
                        if (!isZipFile(file)) return [
                            3,
                            5
                        ];
                        console.log('[useProjectUpload] ZIP 파일 선택됨:', file.name, file.size);
                        setUploadedZipFile(file);
                        setFileTree(null);
                        setProjectFiles([]);
                        setValidationFeedback({
                            message: null,
                            type: 'info'
                        });
                        setUploadError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            analyzeZipFile(file)
                        ];
                    case 2:
                        _ref = _state.sent(), newFileTree = _ref.fileTree, fileList = _ref.fileList;
                        setFileTree(newFileTree);
                        setProjectFiles(fileList);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error('[useProjectUpload] ZIP 파일 처리 중 오류:', error);
                        setUploadedZipFile(null);
                        setFileTree(null);
                        setProjectFiles([]);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        console.log('[useProjectUpload] 잘못된 파일 형식:', file.type);
                        toast(MESSAGES.ERROR.INVALID_ZIP_FORMAT, {
                            icon: '⚠️'
                        });
                        setUploadedZipFile(null);
                        _state.label = 6;
                    case 6:
                        // 입력 필드 초기화
                        if (event.target) {
                            event.target.value = '';
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setFileTree,
        setProjectFiles,
        setUploadError
    ]);
    // ZIP 업로드 트리거
    var triggerZipUpload = useCallback(function() {
        var _zipInputRef_current;
        (_zipInputRef_current = zipInputRef.current) === null || _zipInputRef_current === void 0 ? void 0 : _zipInputRef_current.click();
    }, []);
    var clearZipUpload = useCallback(function() {
        setUploadedZipFile(null);
        setFileTree(null);
        setProjectFiles([]);
        setValidationFeedback({
            message: null,
            type: 'info'
        });
        setUploadError(null);
    }, [
        setFileTree,
        setProjectFiles,
        setValidationFeedback,
        setUploadError
    ]);
    // 뒤로가기 핸들러
    var handleGoBack = useCallback(function() {
        navigate(-1);
    }, [
        navigate
    ]);
    // 폼 제출 핸들러
    var resolveProjectApiBaseUrl = useCallback(function() {
        var provided = process.env.API_URL || process.env.PROJECT_API_BASE_URL;
        if (provided) {
            return provided.replace(/\/$/, '');
        }
        return API_BASE_URLS.API_GATEWAY;
    }, []);
    var getAuthHeader = useCallback(function() {
        try {
            var _tokenManager_getToken, _tokenManager_getTokenType;
            var _tokenManager_getToken1;
            var token = (_tokenManager_getToken1 = tokenManager === null || tokenManager === void 0 ? void 0 : (_tokenManager_getToken = tokenManager.getToken) === null || _tokenManager_getToken === void 0 ? void 0 : _tokenManager_getToken.call(tokenManager)) !== null && _tokenManager_getToken1 !== void 0 ? _tokenManager_getToken1 : typeof window !== 'undefined' ? window.localStorage.getItem('auth_token') : null;
            if (!token) {
                return null;
            }
            var _tokenManager_getTokenType1;
            var tokenType = (_tokenManager_getTokenType1 = tokenManager === null || tokenManager === void 0 ? void 0 : (_tokenManager_getTokenType = tokenManager.getTokenType) === null || _tokenManager_getTokenType === void 0 ? void 0 : _tokenManager_getTokenType.call(tokenManager)) !== null && _tokenManager_getTokenType1 !== void 0 ? _tokenManager_getTokenType1 : typeof window !== 'undefined' ? window.localStorage.getItem('auth_token_type') || 'Bearer' : 'Bearer';
            return "".concat(tokenType || 'Bearer', " ").concat(token).trim();
        } catch (error) {
            console.warn('[useProjectUpload] Failed to resolve auth header:', error);
            return null;
        }
    }, []);
    var buildProjectDetailPath = useCallback(function(projectId) {
        if (typeof window === 'undefined') {
            return "/project/".concat(projectId);
        }
        var segments = window.location.pathname.split('/').filter(Boolean);
        var maybeLang = segments[0];
        var isLangSegment = maybeLang && maybeLang.length === 2;
        var prefix = isLangSegment ? "/".concat(maybeLang) : '';
        return "".concat(prefix, "/project/").concat(projectId);
    }, []);
    var toRelativeUrl = useCallback(function(url) {
        if (!url) {
            return null;
        }
        if (url.startsWith('/')) {
            return url;
        }
        try {
            var parsed = new URL(url);
            return "".concat(parsed.pathname).concat(parsed.search).concat(parsed.hash);
        } catch (e) {
            return url;
        }
    }, []);
    var handleSubmit = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(e) {
            var isZipUpload, isFolderUpload, projectZipToSend, mediaFilesToSend, metadata, filesToSend, formData, metadataPayload, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, requestHeaders, authHeader, requestUrl, response, responseBody, detailMessage, result, _toRelativeUrl, redirectPath, error, _error_response_data, _error_response, detailMessage1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        isZipUpload = uploadedZipFile !== null;
                        isFolderUpload = projectFiles && projectFiles.length > 0;
                        console.log('제출 시도:', {
                            isZipUpload: isZipUpload,
                            isFolderUpload: isFolderUpload,
                            mediaCount: media.length
                        });
                        if (!isZipUpload && !isFolderUpload) {
                            toast(MESSAGES.WARNING.NO_PROJECT_FILES, {
                                icon: '⚠️'
                            });
                            return [
                                2
                            ];
                        }
                        if (isProjectFilesUploading || isMediaUploading) {
                            toast(MESSAGES.WARNING.UPLOAD_IN_PROGRESS, {
                                icon: '⚠️'
                            });
                            return [
                                2
                            ];
                        }
                        setIsSubmitting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            10
                        ]);
                        // 디버깅 시작
                        console.log('[handleSubmit] Current media state:', JSON.stringify(media, null, 2));
                        mediaFilesToSend = media.map(function(item) {
                            console.log('[handleSubmit] Mapping media item:', item, 'File:', _instanceof(item === null || item === void 0 ? void 0 : item.file, File) ? 'File Object' : item === null || item === void 0 ? void 0 : item.file);
                            return item === null || item === void 0 ? void 0 : item.file;
                        }).filter(function(file) {
                            var isFile = _instanceof(file, File);
                            console.log('[handleSubmit] Filtering file:', file, 'Is File?', isFile);
                            return isFile;
                        });
                        console.log('[handleSubmit] Prepared mediaFilesToSend:', mediaFilesToSend);
                        if (!(isZipUpload && uploadedZipFile)) return [
                            3,
                            2
                        ];
                        projectZipToSend = uploadedZipFile;
                        return [
                            3,
                            5
                        ];
                    case 2:
                        if (!(isFolderUpload && projectFiles && projectFiles.length > 0)) return [
                            3,
                            4
                        ];
                        toast(MESSAGES.PROGRESS.PROJECT_COMPRESSING);
                        return [
                            4,
                            createZipFromFiles(projectFiles)
                        ];
                    case 3:
                        projectZipToSend = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        throw new Error(MESSAGES.ERROR.NO_PROJECT_FILES_TO_UPLOAD);
                    case 5:
                        // 메타데이터 준비
                        metadata = {
                            title: formValues.title,
                            description: formValues.description || undefined,
                            tags: formValues.tags
                        };
                        // 모든 파일을 포함하는 단일 배열 준비
                        filesToSend = [
                            projectZipToSend
                        ].concat(_to_consumable_array(mediaFilesToSend));
                        console.log('[handleSubmit] Prepared filesToSend (to be sent):', filesToSend);
                        // API 호출
                        toast(isZipUpload ? MESSAGES.PROGRESS.ZIP_UPLOADING : MESSAGES.PROGRESS.PROJECT_UPLOADING);
                        formData = new FormData();
                        metadataPayload = typeof Blob !== 'undefined' ? new Blob([
                            JSON.stringify(metadata)
                        ], {
                            type: 'application/json'
                        }) : JSON.stringify(metadata);
                        if (_instanceof(metadataPayload, Blob)) {
                            formData.append('metadata', metadataPayload, 'metadata.json');
                        } else {
                            formData.append('metadata', metadataPayload);
                        }
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = filesToSend[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                file = _step.value;
                                formData.append('files', file);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        requestHeaders = {};
                        authHeader = getAuthHeader();
                        if (authHeader) {
                            requestHeaders.Authorization = authHeader;
                        }
                        requestUrl = "".concat(resolveProjectApiBaseUrl()).concat(PROJECT_ENDPOINTS.CREATE);
                        return [
                            4,
                            fetch(requestUrl, {
                                method: 'POST',
                                headers: requestHeaders,
                                body: formData
                            })
                        ];
                    case 6:
                        response = _state.sent();
                        return [
                            4,
                            response.json().catch(function() {
                                return undefined;
                            })
                        ];
                    case 7:
                        responseBody = _state.sent();
                        if (!response.ok) {
                            detailMessage = (responseBody === null || responseBody === void 0 ? void 0 : responseBody.detail) || (responseBody === null || responseBody === void 0 ? void 0 : responseBody.message) || "".concat(MESSAGES.ERROR.PROJECT_SAVE_FAILED(response.statusText));
                            throw new Error(detailMessage);
                        }
                        result = responseBody;
                        if (!(result === null || result === void 0 ? void 0 : result.success) || !result.projectId) {
                            throw new Error((result === null || result === void 0 ? void 0 : result.message) || MESSAGES.ERROR.PROJECT_SAVE_FAILED('프로젝트 ID가 응답에 없습니다.'));
                        }
                        toast.success(/*#__PURE__*/ React.createElement("span", {
                            "data-testid": PROJECT_UPLOAD_TEST_IDS.SAVE_TOAST
                        }, MESSAGES.SUCCESS.PROJECT_SAVED));
                        if (onUploadComplete) {
                            onUploadComplete(_object_spread_props(_object_spread({}, formValues), {
                                media: media,
                                projectId: result.projectId
                            }));
                        } else {
                            ;
                            redirectPath = (_toRelativeUrl = toRelativeUrl(result.redirectUrl)) !== null && _toRelativeUrl !== void 0 ? _toRelativeUrl : buildProjectDetailPath(result.projectId);
                            navigate(redirectPath, {
                                replace: true
                            });
                        }
                        return [
                            3,
                            10
                        ];
                    case 8:
                        error = _state.sent();
                        console.error('프로젝트 처리 또는 저장 오류:', error);
                        detailMessage1 = ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.detail) || error.message || MESSAGES.ERROR.PROJECT_SAVE_FAILED('');
                        toast.error(MESSAGES.ERROR.PROJECT_SAVE_FAILED(detailMessage1));
                        return [
                            3,
                            10
                        ];
                    case 9:
                        setIsSubmitting(false);
                        return [
                            7
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        uploadedZipFile,
        projectFiles,
        media,
        isProjectFilesUploading,
        isMediaUploading,
        formValues,
        onUploadComplete,
        navigate,
        getAuthHeader,
        resolveProjectApiBaseUrl,
        toRelativeUrl,
        buildProjectDetailPath
    ]);
    return {
        // 폼 상태
        formValues: formValues,
        formData: formValues,
        isSubmitting: isSubmitting,
        handleFormChange: handleFormChange,
        setFormData: handleFormChange,
        // 미디어 업로드
        media: media,
        mediaUploadStatus: mediaUploadStatus,
        mediaUploadError: mediaUploadError,
        triggerMediaUpload: triggerMediaUpload,
        handleMediaUpload: handleMediaUpload,
        handleRemoveMediaAdapter: handleRemoveMediaAdapter,
        mediaInputRef: mediaInputRef,
        // 프로젝트 파일 업로드
        fileTree: fileTree,
        projectFiles: projectFiles,
        fileUploadStatus: fileUploadStatus,
        fileUploadProgress: fileUploadProgress,
        uploadError: uploadError,
        triggerFolderUpload: triggerFolderUpload,
        handleFolderUpload: handleFolderUpload,
        folderInputRef: folderInputRef,
        handleDropFolder: handleDropFolder,
        // ZIP 파일 업로드
        uploadedZipFile: uploadedZipFile,
        zipInputRef: zipInputRef,
        handleZipFileChange: handleZipFileChange,
        triggerZipUpload: triggerZipUpload,
        clearZipUpload: clearZipUpload,
        // 유효성 검사
        validationFeedback: validationFeedback,
        // 액션들
        handleGoBack: handleGoBack,
        handleSubmit: handleSubmit,
        // 페이지 제목
        pageTitle: (initialProject === null || initialProject === void 0 ? void 0 : initialProject.fileTree) ? MESSAGES.SUCCESS.PROJECT_SAVED : "새 프로젝트 정보 입력",
        // 디렉토리 업로드 속성
        directoryUploadProps: DIRECTORY_UPLOAD_PROPS
    };
};
